import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { configureApi } from './_helpers/plugins/api-configuration';
import i18n from './_helpers/plugins/i18n';

import App from './App.vue';
import router from './router';
// Importing styles
import 'floating-vue/dist/style.css';
import 'vue-toast-notification/dist/theme-default.css';
import './assets/css/icomoon/style.css';
import './assets/css/fonts.css';
import './assets/css/theme.css';
import './assets/css/base.css';
import './assets/css/vendor-overrides.css';

// Importing plugins and components
import DateRange from '@/components/shared/date-range/DateRange.vue';
import FloatingVue from 'floating-vue';
import VueApexCharts from 'vue3-apexcharts';

// Create Vue app instance
const app = createApp(App);

// Sentry Error Tracking Initialization
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', import.meta.env.VITE_SENTRY_PROPAGATION_TARGET_REGEX],
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.5, // Capture 50% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample rate at 10%
  replaysOnErrorSampleRate: 1.0, // Sample rate at 100% when errors occur
});

// Register plugins
app.use(createPinia());
app.use(router);
app.use(i18n);
app.component('apexchart', VueApexCharts);
app.use(FloatingVue, {
  themes: {
    'inocu-tooltip': {
      $extend: 'tooltip',
    },
  },
});

// Register global components
app.component('DateRange', DateRange);

// Configure API
configureApi();

// Mount the app
app.mount('#app');
